// 留扩展点, 当前 M1 无 model 关系添加
export default [];